import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
	selector: 'app-snackbar-warning',
	templateUrl: './snackbar-warning.component.html',
	styleUrls: ['./snackbar-warning.component.scss'],
	host: { class: 'w-100 d-flex justify-content-between'}
})
export class SnackbarWarningComponent implements OnInit {

	constructor(
		public snackBarRef: MatSnackBarRef<SnackbarWarningComponent>,
		@Inject(MAT_SNACK_BAR_DATA) public data: any,
	) { }

	ngOnInit(): void {
	}

}
